import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { ChatInputBar } from "common/elements";
import { MessageContentType } from "features/user/types";
import { sendContactChatRoomMessage } from "features/user/api";

export const ContactInputBar = ({ onShowCard }: { onShowCard: () => void }) => {
  const play = usePlaySound();
  const location = useLocation();
  const selectedChatRoomId = useSelector((state: RootState) => state.user.selectedChatRoomId);
  const user = useSelector((state: RootState) => state.user.active);

  const handleSend = (text: string, imageUrl?: string) => {
    if (!text && !imageUrl) return;

    const hasImage = !!imageUrl;
    const hasText = !!text.trim();
    const contentType = hasImage
      ? hasText
        ? MessageContentType.IMAGE_WITH_TEXT
        : MessageContentType.IMAGE
      : MessageContentType.TEXT;
    const content = hasImage
      ? hasText
        ? { url: imageUrl, text: text.trim() }
        : { url: imageUrl }
      : { text: text.trim() };

    sendContactChatRoomMessage({
      uid: user.uid,
      roomId: selectedChatRoomId,
      message: {
        url: `${location.pathname}${location.search}`,
        message_content_type: contentType,
        message_content: content,
      },
    }).catch((error) => {
      console.error(JSON.stringify(error));
      toast(
        <div>
          <p className="text text-textcolor-black">{I18n.t("MSG_TOAST_SEND_FAILED")}</p>
        </div>,
      );
    });
  };

  const handleShowCard = () => {
    play();
    onShowCard();
  };

  return (
    <ChatInputBar
      onSend={handleSend}
      disabled={selectedChatRoomId === null}
      placeholder={I18n.t("MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER")}
      hideAssetButtons
      leadingButton={
        <button
          onClick={handleShowCard}
          disabled={selectedChatRoomId === null}
          className="flex-col-el flex-center shrink-0 cursor-pointer border-2 border-solid active:opacity-70 disabled:opacity-50 rounded-lg w-[52px] h-[52px] transition-colors bg-white border-blue-60 hover:bg-blue-20"
        >
          <span className="material-symbols-outlined type-title text-blue-100">menu</span>
        </button>
      }
    />
  );
};
